import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardTagsFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'idTags'>
);

export const BoardTagsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardTags' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idTags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardTagsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<BoardTagsFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardTagsFragmentResult
  extends Omit<Apollo.UseFragmentResult<BoardTagsFragment>, 'data'> {
  data?: BoardTagsFragment;
}

export const useBoardTagsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardTagsFragmentOptions): UseBoardTagsFragmentResult => {
  const result = Apollo.useFragment<BoardTagsFragment>({
    ...options,
    fragment: BoardTagsFragmentDoc,
    fragmentName: 'BoardTags',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardTagsFragment };
};
